import { showToastr, toastrError } from '../utils/toast';
import { axiosApiInstanceHeaders } from './ManageToken'

async function login(values) {
  return axiosApiInstanceHeaders.post(
    `${process.env.REACT_APP_API_URL}login`,
    values
  ).then(response => {
    if (response.status === 201) {
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user_data', JSON.stringify(response.data.user));
      showToastr('success', 'Correcto.', 'Sesión iniciada.', 2500, true, true, 'top-right');
    }else{
      showToastr('error', 'Email/contraseña incorrectos.', 'Vuelve a intentarlo.', 2500, true, true, 'top-right');
    }
    return response;
  }).catch(function (error) {
    toastrError(error);
    return Promise.reject(error);
  });
}

function logout(){
    localStorage.clear();
    showToastr('info', 'Sesión cerrada','Has salido de tu cuenta.', 2500, true, true, 'top-right');
    return true;
}

export const authServices = {
  login,
  logout
};
